import type { ProfileType, UserSession } from '@/types/models'
import { routes } from '@/app/routes'

/** The one rule every sign-in path (verify, profile completed, boot) follows to pick the next screen; mirrors mobile auth_destination.dart. */
export type AuthDestination = 'signIn' | 'completeProfile' | 'tenantHome' | 'landlordHome'

export function authDestination(user: UserSession | null | undefined): AuthDestination {
  if (!user) return 'signIn'
  if (!user.profileCompleted) return 'completeProfile'
  return user.defaultProfile === 'tenant' ? 'tenantHome' : 'landlordHome'
}

export function homeFor(profile: ProfileType): string {
  return profile === 'tenant' ? routes.tenant.dashboard : routes.landlord.dashboard
}

export function destinationPath(destination: AuthDestination): string {
  switch (destination) {
    case 'signIn':
      return routes.login
    case 'completeProfile':
      return routes.completeProfile
    case 'tenantHome':
      return routes.tenant.dashboard
    case 'landlordHome':
      return routes.landlord.dashboard
  }
}

/** Only allow same-origin, in-app paths as a post-login redirect. */
export function safeNextPath(next: string | null | undefined): string | null {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return null
  return next
}
